import { getDashboard as fetchDashboard } from "@/infrastructure/services/dashboardService";
import { useEmpreendedoraStore } from "@/stores/empreendedoraStore";
import type { DashboardData } from "@/types/dashboard";
import { useCallback, useState } from "react";

const initialDashboardData: DashboardData = {
  nome: "",
  negocioId: null,
  dashboard: {
    emailVerificado: false,
    perfilCompleto: false,
    possuiProdutos: false,
    possuiProdutosPublicados: false,
    compartilhouRedesSociais: false,
  },
  visibilidade: {
    visualizacoesPerfil: { total: 0, variacaoPercentual: null },
    visualizacoesProdutos: { total: 0, variacaoPercentual: null },
    cliquesWhatsapp: { total: 0, variacaoPercentual: null },
  },
  produtos: {
    produtos_cadastrados: 0,
    visiveis_vitrine: 0,
    nao_publicados: 0,
  },
};

export function useDashboard() {
  const setNome = useEmpreendedoraStore((state) => state.setNome);
  const setPerfilCompleto = useEmpreendedoraStore(
    (state) => state.setPerfilCompleto,
  );
  const setNegocioId = useEmpreendedoraStore((state) => state.setNegocioId);
  const [dashboardData, setDashboardData] =
    useState<DashboardData>(initialDashboardData);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  const getDashboard = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await fetchDashboard();
      setDashboardData(data);
      setNome(data.nome);
      setNegocioId(
        data.negocioId === null || data.negocioId === undefined
          ? null
          : String(data.negocioId),
      );
      setPerfilCompleto(data.dashboard.perfilCompleto);
      return data;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    } finally {
      setIsLoading(false);
    }
  }, [setNegocioId, setNome, setPerfilCompleto]);

  return { dashboardData, isLoading, error, getDashboard };
}
